<template>
  <full-width-sidebar-left
      tab-selector="datasourcetab"
      type="datasource"
      back-button-tab-selector="datasourcebackbutton"
      :id="$route.params.id"
      sub-menu-selector="librarypanel"
  >
    <info-panel
        slot="sidebarLeft"
        :created="$store.getters.getDatasourceCreationDate(this.$route.params.id)"
        :last-change="$store.getters.getDatasourceChangeDate(this.$route.params.id)"
        preview-id="datasourceEdit"
        :organization="$store.getters.getDatasourceOrganization($route.params.id)"
    />
    <team-attacher
        v-if="$store.getters.getDatasourceOrganization($route.params.id)"
        slot="sidebarLeft"
        class="mt-3"
        :id="$route.params.id"
        :teams="teams"
        store-name="Asset"
        :limit-by-organization-id="$store.getters.getDatasourceOrganization($route.params.id)"
        @added="loadAssetTeams"
        @removed="loadAssetTeams"
    />
    <info-panel
        slot="sidebarLeft"
        :id="$route.params.id"
        :tags="$store.getters.getDatasourceTags($route.params.id)"
        :taggable="true"
        preview-id="datasourceEdit"

        @removeTag="removeTag"
        @addTag="addTag"
        :key="'infopanel2'"
        :limit-tags-to-organization="$store.getters.getDatasourceOrganization($route.params.id)"
    />
    <template slot="mainContent">
      <content-title-block
          v-if="$store.getters.getDatasourceName($route.params.id)"
          :value="$store.getters.getDatasourceName($route.params.id)"
          :id="$route.params.id"
          store-name="Datasource"
          :organization-id="$store.getters.getDatasourceOrganization($route.params.id)"
          @updated="loadDataSource"
      />
      <content-description-block
          :value="$store.getters.getDatasourceDescription(id)"
          :id="$route.params.id"
          store-name="Datasource"
          @updated="loadDataSource"
      />
      <div class="row">
        <div v-if="$store.getters.getDatasourceType($route.params.id) === 'feed'" class="col-12 mb-2">
          <feed-edit
              v-if="$store.getters.getDatasourceMetaSets($route.params.id)"
              class="feed-panel p-3"
              :meta-sets="$store.getters.getDatasourceMetaSets($route.params.id)"
              :teams="teams"
          />
        </div>
        <div class="col-12" v-else>
          16:28 Begin
          <sensor-edit
              v-if="$store.getters.getDatasourceMetaSets($route.params.id)"
              class="feed-panel p-3"
              :sensor-id="$route.params.id"
              :meta-sets="$store.getters.getDatasourceMetaSets($route.params.id)"
              :sensor-name="$store.getters.getDatasourceName($route.params.id)"
          />
        </div>

        <meta-panel
            v-if="$store.getters.getDatasourceMetaSets($route.params.id)"
            class="col-12 col-md-6 col-xl-11 col-xxl-8 mt-3"
            store-name="Datasource"
            :key="item.id"
            v-for="(item) in $store.getters.getDatasourceMetaSets($route.params.id)"
            :title="item.description"
            :fields="item.metaFields"
            icon-left="folder"
            :organization-ids="[$store.getters.getDatasourceOrganization($route.params.id)]"
            @updated="loadDataSource"
            :teams="teams"
        />
      </div>
    </template>
  </full-width-sidebar-left>
</template>

<script>
import FullWidthSidebarLeft from "../layouts/FullWidthSidebarLeft";
import MetaPanel from "../components/widgets/meta/MetaPanel";
import ContentTitleBlock from "../components/ContentTitleBlock";
import ContentDescriptionBlock from "../components/ContentDescriptionBlock";
import InfoPanel from "../components/InfoPanel";
import TeamAttacher from "@/components/organizations/TeamAttacher";
import FeedEdit from "../components/FeedEdit.vue";
import SensorEdit from "../components/SensorEdit.vue";

export default {
  name: 'DataSourceEdit',
  components: {
    MetaPanel,
    FullWidthSidebarLeft,
    ContentTitleBlock,
    ContentDescriptionBlock,
    InfoPanel,
    TeamAttacher,
    FeedEdit,
    SensorEdit
  },
  data() {
    return {
      listName: 'DatasetList',
      id: '',
      teams: [],
    };
  },
  watch: {
    '$route.params'() {
      this.init();
    }
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      this.loadDataSource();
      this.loadAssetTeams();
      this.id = this.$route.params.id;
    },
    loadDataSource() {
      this.$store.dispatch('loadDatasource', {
        id: this.$route.params.id,
        include: 'metaSets,tags'
      }).catch(e => {
        if (e.status === 401) {
          this.$router.push('/access-denied');
        } else if (e.status === 404) {
          this.$router.push('/not-found')
        }
      });
    },
    loadAssetTeams() {
      this.$store.dispatch('clientLoadAssetTeams', {
        id: this.$route.params.id
      }).then(data => {
        this.teams = data;
      });
    },
    removeTag: function (tag) {
      this.$store.dispatch('removeDatasourceTag', {
        id: this.$route.params.id,
        args: [tag.id],
      });
    },
    addTag: function (tag) {
      this.$store.dispatch('addDatasourceTag', {
        id: this.$route.params.id,
        args: [tag.id],
      });
    },

  },
}
</script>

<style lang="scss" scoped>
.feed-panel {
  background-color: var(--vform-editor-ui-secondary-color);
}
</style>
